<!-- Divider pill marking the boundary between read and unread messages in a chat. -->

<script lang="ts" setup>
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';

import * as l from './NewMessagesIndicator.loc.js';

const t = useTranslate();
</script>

<template>
  <div
    :class="css.indicator"
    data-new-messages-indicator
  >
    <div :class="css.line" />
    <div :class="css.pill">
      <div :class="css.dot" />
      <div :class="css.text">{{ t(l.newMessages) }}</div>
    </div>
    <div :class="css.line" />
  </div>
</template>

<style lang="scss" module="css">
.indicator {
  display: flex;
  align-items: center;
  padding: $spacing-08 $spacing-16;
  gap: $spacing-12;
}

.line {
  flex: 1;
  height: 1px;
  background: $color-doctor-200;
}

.pill {
  display: flex;
  align-items: center;
  gap: $spacing-08;
  padding: $spacing-04 $spacing-12;
  background: $color-white;
  border-radius: 9999px;
  box-shadow: soft-shadow(10px, 0.3);
  flex-shrink: 0;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: $color-red-500;
  flex-shrink: 0;
}

.text {
  font-size: $font-size-12;
  color: $color-gray-900;
  white-space: nowrap;
}
</style>
